import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { RouterOutlet } from '@angular/router';
import { SideMenuComponent } from './core/components/side-menu/side-menu.component';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
    TegelModule,
    SideMenuComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent
],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent {
}
